import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const QRCodeGenerator = ({ value, size = 192, className = '' }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrDataUrl, setQrDataUrl] = useState(null);

  useEffect(() => {
    console.log('🎯 QRCodeGenerator useEffect triggered:', {
      hasValue: !!value,
      valueLength: value?.length,
      valueType: typeof value,
      value: value?.substring(0, 100) + (value?.length > 100 ? '...' : '')
    });

    if (value) {
      setLoading(true);
      setError(null);
      setQrDataUrl(null);
      
      console.log('📱 Tentando gerar QR Code...');
      
      // Gerar QR Code usando DataURL (mais compatível)
      QRCode.toDataURL(value, {
        width: size,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      })
      .then(dataUrl => {
        console.log('✅ QR Code DataURL gerado com sucesso');
        setQrDataUrl(dataUrl);
        setLoading(false);
      })
      .catch(err => {
        console.error('❌ Erro ao gerar QR Code DataURL:', err);
        setError(`Erro ao gerar QR Code: ${err.message}`);
        setLoading(false);
      });
    } else {
      console.log('⚠️ QR Code não pode ser gerado: sem valor');
      setLoading(false);
      setError(null);
      setQrDataUrl(null);
    }
  }, [value, size]);

  if (!value) {
    return (
      <div 
        className={`bg-gray-100 flex items-center justify-center text-gray-400 rounded-lg ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="text-center text-sm">
          <div className="text-2xl mb-2">📱</div>
          QR Code não disponível
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className={`bg-red-50 border border-red-200 flex items-center justify-center text-red-600 rounded-lg ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="text-center text-sm">
          <div className="text-2xl mb-2">❌</div>
          <div>Erro ao gerar QR Code</div>
          <div className="text-xs mt-1">{error}</div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div 
        className={`bg-gray-100 flex items-center justify-center text-gray-500 rounded-lg ${className}`}
        style={{ width: size, height: size }}
      >
        <div className="text-center">
          <div className="animate-spin text-2xl mb-2">⏳</div>
          <div className="text-sm">Gerando QR Code...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      {qrDataUrl && (
        <img 
          src={qrDataUrl}
          alt="QR Code PIX"
          width={size}
          height={size}
          className="border rounded-lg shadow-sm"
          style={{ 
            maxWidth: '100%', 
            height: 'auto',
            display: 'block'
          }}
        />
      )}
    </div>
  );
};

export default QRCodeGenerator;
